export const descriptionText = "text-sm text-slate-400";
